import React from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import RatingsDashboard from '../components/pages/RatingsDashboard';
import StripeTipPreview from '../components/pages/StripeTipPreview';
import ReviewRequestPreview from '../components/pages/ReviewRequestPreview';
import ReferralRequestPreview from '../components/pages/ReferralRequestPreview';
import ReferralDashboardPreview from '../components/pages/ReferralDashboardPreview';
import ReferralActivityPreview from '../components/pages/ReferralActivityPreview';
import ReferralAuthPreview from '../components/pages/ReferralAuthPreview';
import ReferralLandingFormPreview from '../components/pages/ReferralLandingFormPreview';
import ConfigurableFlowPreview from '../components/pages/ConfigurableFlowPreview';
import RootDomainRedirect from '../components/domain/RootDomainRedirect';

/**
 * Application-level routes
 * Handles navigation, redirects, and error pages
 */
export const appRoutes: RouteObject[] = [
  {
    path: '/',
    element: <RootDomainRedirect />,
    id: 'root-redirect'
  },
  {
    path: '*',
    element: <Navigate to="/ratings" replace />,
    id: 'catch-all'
  }
];

/**
 * Future dashboard/ratings routes
 * Placeholder for when ratings dashboard is implemented
 */
export const dashboardRoutes: RouteObject[] = [
  {
    path: '/ratings',
    element: <RatingsDashboard />,
    id: 'ratings-dashboard'
  },
  {
    path: '/dashboard',
    element: <RatingsDashboard />,
    id: 'dashboard'
  },
  {
    path: '/preview/stripe-tip',
    element: <StripeTipPreview />,
    id: 'stripe-tip-preview'
  },
  {
    path: '/preview/tip-checkout',
    element: <StripeTipPreview />,
    id: 'tip-checkout-preview'
  },
  {
    path: '/preview/review-request',
    element: <ReviewRequestPreview />,
    id: 'review-request-preview'
  },
  {
    path: '/preview/referral-request',
    element: <ReferralRequestPreview />,
    id: 'referral-request-preview'
  },
  {
    path: '/preview/referral-dashboard',
    element: <ReferralDashboardPreview />,
    id: 'referral-dashboard-preview'
  },
  {
    path: '/preview/referral-activity',
    element: <ReferralActivityPreview />,
    id: 'referral-activity-preview'
  },
  {
    path: '/preview/referral-auth',
    element: <ReferralAuthPreview />,
    id: 'referral-auth-preview'
  },
  {
    path: '/preview/referral-landing',
    element: <ReferralLandingFormPreview />,
    id: 'referral-landing-preview'
  },
  {
    path: '/r/:referralCode',
    element: <ReferralLandingFormPreview />,
    id: 'referral-landing-public'
  },
  {
    path: '/preview/configurable-flow',
    element: <ConfigurableFlowPreview />,
    id: 'configurable-flow-preview'
  }
];
